import { labels } from '../lib/labels';

export function NotFound({ path }: { path: string }) {
  return (
    <div>
      <div className="page-head">
        <h2>{labels.pageTitles.notFound}</h2>
      </div>
      <p className="notice">
        <code>#{path}</code> isn&apos;t one of the console&apos;s routes. <a href="#processing">Go to {labels.nav.processing}</a>.
      </p>
    </div>
  );
}
